import { Injectable } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { CommonService } from 'src/app/service/common.service';
import { HttpBasicService } from 'src/app/service/http-basic.service';
import { ExpiryItemRec } from '../0_def/expiry-item-rec';
import { ReqGetExpiryItemByJan, RspGetExpiryItemByJan } from 'src/app/webservice/item-expiry';

@Injectable({
  providedIn: 'root'
})
export class ItemExpiryService {

  constructor(
    private commonService: CommonService,
    private httpBasic: HttpBasicService,
    private _snackBar: MatSnackBar
    ) {
  }

  getExpiryItemByJan(storeCd: string, itemCd: string, targetGroupUsrCd: string, targetDate: string): Promise<ExpiryItemRec> {
    return new Promise<ExpiryItemRec>((resolve) => {
      let request: ReqGetExpiryItemByJan = {
        access: this.commonService.loginUser,
        storeCd: storeCd,
        itemCd: itemCd,
        targetDate: targetDate
      };
  
      let ref= this.commonService.openSpinnerForSubComp(this.commonService.pageTitle, "検索中・・・");
      let subsc = this.httpBasic.generalRequest("GetExpiryItemByJan", request).subscribe(
        (response: RspGetExpiryItemByJan) => {
          subsc.unsubscribe();
          this.commonService.closeSpinnerForSubComp(ref);
          resolve(this.receiveQueryItem(response, targetGroupUsrCd, targetDate));
        },
        (error) => {
          subsc.unsubscribe();
          this.commonService.closeSpinnerForSubComp(ref);
          this.httpBasic.handleError(error);
          resolve(undefined);
        }
      );
    });
  }

  receiveQueryItem(response: RspGetExpiryItemByJan, targetGroupUsrCd: string, targetDate: string): ExpiryItemRec {
    if (this.httpBasic.handleAppError(response)) return undefined;

    if (!response.item) {
      return null;
    }

    let rec = new ExpiryItemRec(this.commonService, this.httpBasic);
    rec.setTargetDate(this.commonService.getDate(targetDate));
    rec.initByDto(response.item, response.groups, response.itemDates, targetGroupUsrCd);
     return rec;
  }
}
